import React from "react";
import { Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";

interface InvestmentEntityTextProps {
  investmentEntityName: string;
}

/**
 * InvestmentEntityText component.
 *
 * This component renders the name of an investment entity with a specific color.
 *
 * @component
 * @param {InvestmentEntityTextProps} props - The component props.
 * @param {string} investmentEntityName - The name of the investment entity.
 *
 * @example
 * <InvestmentEntityText position={position} />
 */
const InvestmentEntityText: React.FC<InvestmentEntityTextProps> = ({
  investmentEntityName,
}) => {
  return (
    <Text color={Colors.Neutral800} variant="regular-sm">
      {investmentEntityName}
    </Text>
  );
};

export default InvestmentEntityText;
